import { render, staticRenderFns } from "./cancelacionEstados.vue?vue&type=template&id=6ed02006&scoped=true&"
import script from "./cancelacionEstados.vue?vue&type=script&lang=js&"
export * from "./cancelacionEstados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed02006",
  null
  
)

export default component.exports